export const SEND_BLOCKLIST_ACCESS_TOKEN_FETCH = 'SEND_BLOCKLIST_ACCESS_TOKEN_FETCH';
export const SEND_BLOCKLIST_ACCESS_TOKEN_DATA = 'SEND_BLOCKLIST_ACCESS_TOKEN_DATA';
export const SEND_BLOCKLIST_ACCESS_TOKEN_ERROR = 'SEND_BLOCKLIST_ACCESS_TOKEN_ERROR';

export const SET_BLOCKLIST_STATUS = 'SET_BLOCKLIST_STATUS';
